import React from "react";
import { Button } from "antd";
import GeneralBloc from "../../../bloc/general_bloc";

class AppSubButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() { }
  propButtonWidth() {
    return this.props.buttonWidth;
  }

  propButtonWidth() {
    return this.props.buttonWidth;
  }

  stateIsWithArrow() {
    return !this.props.isWithoutArrow;
  }

  getStyles() {
      let style = {
        backgroundColor: "#EE7623",
        color: "#FFFFFF",
        height: '48px',
        width: '170px',
        fontSize: "14px",
        fontWeight: '600',
        // paddingLeft: "30px",
        // paddingRight: "30px",
        border: "0px solid transparent",
        // width: this.propButtonWidth() || "",
      };

    return style;
  }

  render() {
    return (
      <Button onClick={(e) => this.props.onClick(e)} style={this.getStyles()}>
        {this.props.label}
      </Button>
    );
  }
}

export default AppSubButton;
